export default __webpack_public_path__ + "static/media/ntv-brands.80404639.png";